export default __webpack_public_path__ + "f69c7d1cf6382c4b0c5bb4f98949b500.mp3";